export const columnArrF = [
    'bitrix',
    'Bitrix24',
    'Pricing',
    'Media kit',
    'Contact us',
    'In the press',
]
export const columnArrSe = [
    'support',
    'Helpdesk',
    'Webinars',
    'How-to videos',
    'Submit a ticket',
    'Schedule a demo',
    'Bitrix24 Status page'
]
export const columnArrT =[
    'resources',
    'Blog',
    'Solutions',
    'Testimonials',
    'Alternatives',
    'Uses',
    'Guides',
    'Research'
]

export const columnArrFo = [
    'on-premise',
    'On-premise edition',
    'Download',
    'Documentation',
]

export const columnArrFi = [
    'apps',
    'Market',
    'Mobile app',
    'Desktop app',
    'API/developers'
]

export const columnArrS = [
    'partners',
    'Find a partner',
    'Become a partner',
    'Partner login'
]